var $name="imageNaturalSizes",$path="configs/imageNaturalSizes.js",$this={$name,$path,};module.exports = {
  width: 120,
  height: 90,
};
